<template>
  <v-container>
    <v-carousel
      height="auto"
      :value="model"
      :cycle="isCycle"
      :show-arrows="showArrows"
      :hide-delimiters="hideDelimiter"
      hide-delimiter-background
      :interval="3000"
    >
      <v-carousel-item v-for="(item, i) in items" :key="`carousel-${i}`" @click="$emit('action', i)">
        <v-img v-show="item.src" :src="item.src" :lazy-src="placeholderImage" eager contain :height="fixHeight" :max-height="maxHeight" />
        <iframe
          title="Video"
          :width="iframeWidth"
          :height="iframeHeight"
          v-show="item.url"
          :src="item.url"
          frameborder="0"
          allow="autoplay; fullscreen"
        ></iframe>
      </v-carousel-item>
    </v-carousel>
  </v-container>
</template>

<script>
import placeholderImage from '@/assets/placeholder.png';

export default {
  name: 'CarouselBox',
  props: {
    items: { type: Array, required: true },
    showArrows: { tyep: Boolean, default: false },
    hideDelimiter: { type: Boolean, default: false },
    isCycle: { type: Boolean, default: true },
    model: { type: Number, default: 0 },
    isVideo: { type: Boolean, default: false },
    imgMaxHeight: { type: String, default: '0' },
    fixHeight: { type: String, default: 'auto' },
  },
  data: () => ({
    placeholderImage,
  }),
  computed: {
    maxWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '350';
        case 'sm':
          return '780';
        case 'md':
          return '1280';
        case 'lg':
        default:
          return '1600';
      }
    },
    maxHeight() {
      if (this.imgMaxHeight > 0) {
        return this.imgMaxHeight;
      }
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '230';
        case 'sm':
          return '400';
        case 'md':
          return '550';
        case 'lg':
        default:
          return '750';
      }
    },
    iframeHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return this.isVideo ? '180' : '90';
        case 'sm':
          return this.isVideo ? '360' : '200';
        case 'md':
          return this.isVideo ? '480' : '200';
        default:
        case 'lg':
          return this.isVideo ? '720' : '300';
      }
    },
    iframeWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return this.isVideo ? '300' : '160';
        case 'sm':
          return this.isVideo ? '600' : '480';
        case 'md':
          return this.isVideo ? '854' : '400';
        default:
        case 'lg':
          return this.isVideo ? '1280' : '800';
      }
    },
  },
};
</script>
